import { renderValidations } from "../../../shared/Table/table.utils";

// Config for table and form
const tableConfig = [
  { id: "email", validations: { required: true, email: true } },
];

export const FORM_OPTIONS = { validations: renderValidations(tableConfig) };
